export enum ProfileRole {
	Admin = 'ADMIN',
	Operator = 'OPERATOR',
}
